import styled from 'styled-components';
import { Link } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import logo from "../../images/idle.png";

export const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  min-height: 100vh;
  min-width: 100vw;
  background-color: #17191c;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const MenuButton = styled(Link)`
  position: absolute;
  left: 50%;
  bottom: 50px;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledOverview1Link = styled(Link)`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  color: transparent;
`;
